import React, { createRef, useEffect } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  & > :first-child {
    border: ${({ theme, isSelected }) => isSelected ? `2px solid ${theme._neo.focus01}` : '2px solid black'};
    cursor: pointer;
    height: 100%;
    width: 100%;

    ${({ height, orientation, width }) => orientation === 'vertical'
? `
      height: ${height}px;
      margin-bottom: 4px;
      width: 100%;
    `
: `
      height: 100%;
      margin-right: 4px;
      width: ${width}px;
    `};
  }
`

const SlideshowItem = ({
  height,
  isSelected,
  orientation,
  SlideComponent,
  slideProps,
  width
}) => {
  const ref = createRef()

  useEffect(() => {
    isSelected && ref.current.scrollIntoView({
      block: 'center',
      inline: 'center'
    })
  }, [isSelected])

  return (
    <Container
      height={height}
      isSelected={isSelected}
      orientation={orientation}
      ref={ref}
      width={width}
    >
      <SlideComponent
        {...slideProps}
      />
    </Container>
  )
}

export default SlideshowItem
